export default {
  close: {
    id: 'design_system_button_close',
    defaultMessage: 'Close',
  },
}
